export default __webpack_public_path__ + "static/media/id.a45b4d32.svg";